// Each class carries its department's colour (departments.sticker_color) so a
// teacher can tell classes apart at a glance across Studio, Classes and the
// class pop-up. Departments without a valid sticker get a stable palette colour.

export const FALLBACK_HUES = ['#3B82F6', '#14B8A6', '#F59E0B', '#F43F5E', '#8B5CF6', '#10B981', '#F97316', '#06B6D4'];

const HEX = /^#[0-9a-f]{6}$/i;
const INK_BASE = [15, 23, 42]; // slate-900
const INK_MIX = 0.6;

export function classColor(stickerColor, key = '') {
  if (HEX.test(stickerColor || '')) return stickerColor;
  let hash = 0;
  for (const ch of String(key)) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  return FALLBACK_HUES[hash % FALLBACK_HUES.length];
}

// A darker shade of the colour for text and icons drawn on its own light tint.
export function classInk(hex) {
  const rgb = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
  return `#${rgb
    .map((c, i) => Math.round(c * (1 - INK_MIX) + INK_BASE[i] * INK_MIX).toString(16).padStart(2, '0'))
    .join('')}`;
}
